export default __webpack_public_path__ + "media/images/ui-bg_glass_80_d7ebf9_1x400-0687b0cac1bf682ba9c66efca0c2e30e.png";